import axios, { AxiosInstance, AxiosRequestConfig, AxiosError, HeadersDefaults } from 'axios';
import { DataSourceManager } from './dataSourceManager/dataSourceManager';

interface Headers extends HeadersDefaults {
  Country: string;
  Language: string;
  SessionToken: string;
  SearchProfile: string;
}
interface HttpInitConfig {
  country: string;
  language: string;
}

export interface HttpError extends AxiosError {}

/**
 * A wrapper on axios instance adjusted to the needs of this project.
 */
export class Http {
  constructor(public client: AxiosInstance, private dataSourceManager: DataSourceManager) {
    this.client.defaults.baseURL = this.dataSourceManager.fssCoreAPI;
  }

  setConfig({ country, language }: HttpInitConfig) {
    (this.client.defaults.headers as Headers).Country = country;
    (this.client.defaults.headers as Headers).Language = language;
  }

  /**
   * Set the session token as a request header
   * @param searchProfile - A UUID token
   */
  setSessionToken(token: string): void {
    (this.client.defaults.headers as Headers).SessionToken = token;
  }

  /**
   * Set the search profile as a request header
   * @param searchProfile - A UUID token
   */
  setSearchProfile(searchProfile: string): void {
    (this.client.defaults.headers as Headers).SearchProfile = searchProfile;
  }

  get<T>(url: string, options?: AxiosRequestConfig) {
    return this.client.get<T>(url, options);
  }

  post<T>(url: string, data: unknown, options?: AxiosRequestConfig) {
    return this.client.post<T>(url, data, options);
  }
}

interface Headers extends HeadersDefaults {
  Market: string;
  Language: string;
}

const httpClient = axios.create({
  timeout: 5000,
  baseURL: process.env.VUE_APP_FSS_CORE,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ApplicationName: process.env.VUE_APP_NAME as string,
  },
});

function setDetfaults(baseUrl: string, country: string, language: string): void {
  (httpClient.defaults.headers as Headers).Market = country;
  (httpClient.defaults.headers as Headers).Language = language;
  httpClient.defaults.baseURL = baseUrl;
}

export default { setDetfaults };
export { httpClient };
